<style src="@/assets/css/base.css" type="text/css" media="all"></style>
<style src="@/assets/css/admin_common.css" type="text/css" media="all"></style>
<style src="@/assets/css/common_common.css" type="text/css" media="all"></style>
<style src="@/assets/css/common_layout.css" type="text/css" media="all"></style>

<style>
	.slideFadeIn-enter-active, .slideFadeIn-leave-active {
		transition: all .5s ease;
	}
	.slideFadeIn-enter, .slideFadeIn-leave-to {
		opacity: 0;
		transform: translateY(-100%);
	}
	.slideFadeIn-enter-to, .slideFadeIn-leave {
		opacity: 1;
		transform: translateY(0%);
	}

</style>
<template>
	<!-- ☆ 酒井さん仕様 ここから -->
	<div id="app" class="main">
		<!-- ▼ header -->
		<header id="mainAH" v-if="!isCommon">
			<h1>けんしんWEB<span>けんしんWEB《管理者様用》</span></h1>
		</header>

		<header id="mainCH" v-if="isCommon">
			<h1>けんしんWEB<span>けんしんWEB</span></h1>
		</header>

		<div id="mainAC" v-if="!isCommon">
			<transition name="slideFadeIn">
				<nav class="sideMenu" v-show=isAdminGlobalMenuMaster>
					<h2>マスタ管理</h2>
					<ul>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(0)">医療機関情報マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(1)">メールテンプレートマスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(2)">休業日マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(3)">検査項目マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(4)">オプション分類マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(5)">オプション項目マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(6)">時間帯マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(7)">予約枠マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(8)">予約登録枠数管理マスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(9)">クライアントマスタ</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(10)">コースマスタ</a></li>
					</ul>
					<a class="closeBtn" v-on:click="onClickCloseGlobalMenu">close</a>
				</nav>
			</transition>
			<transition name="slideFadeIn">
				<nav class="sideMenu" v-if=isAdminGlobalMenuReserve>
					<h2>予約管理</h2>
					<ul>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(51)">状況照会</a></li>
						<li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(52)">受診者抽出</a></li>
					    <li><a href="javascript:void(0)" v-on:click="onClickGlobalMenuLink(53)">CSVパターン一覧</a></li>
					</ul>
					<a class="closeBtn" v-on:click="onClickCloseGlobalMenu">close</a>
				</nav>
			</transition>
			<!-- ▽ memberHeader -->
			<section id="memberHeader" v-if=isAdminUserLogin>
				<ul id="memberProfile">
					<li class="name">{{getAdminUserName}}</li>
				</ul>
				<nav class="globalMenu">
					<ul>
						<li v-bind:class="getIsActive('1')"><a href="#" v-on:click="onClickGlobalMenuTop">TOP</a></li><li v-bind:class="getIsActive('2')"><a href="#" v-on:click="onClickGlobalMenuReserve">予約管理</a></li><li v-bind:class="getIsActive('3')"><a href="#" v-on:click="onClickGlobalMenuMaster">マスタ管理</a></li><li id="logout"><a href="#" v-on:click="onAdminLogout">ログアウト</a></li>
					</ul>
				</nav>
			</section>
			<router-view />
		</div>

		<div id="mainCC" v-if="isCommon">
			<span class="bg1" v-bind:style="getStyle"></span>
			<!-- ★ 雲財 仮追加 memberHeader information -->
			<section id="memberHeader" v-if="isCommonHeaderFooter">
				<ul id="memberProfile" v-if="isCommonUserLogin">
					<li class="name">{{getCommonUserName}}</li>
				</ul>
				<nav class="menu">
					<div v-bind:class="getNavigationClassName">
						<h3 v-on:click="onMenu()">MENU</h3>
						<!-- ナビゲーションメニュー表示時はクラスmenuOnがulに設定される -->
						<ul>
          	  <!-- ログインしていればマイページ（ホーム）、してなければトップページへ -->
							<li><a v-on:click="onHome" v-if="isCommonUserLogin">HOME</a><a v-on:click="onHome" v-else>Top</a></li>
							<li class="logout" v-if="isCommonUserLogin"><a v-on:click="onLogout">ログアウト</a></li>
							<li class="pw" v-if="isCommonUserLogin"><a v-on:click="onChangePassword">パスワード変更</a></li>
						</ul>
					</div>
				</nav>
			</section>
			<section id="information">
				<div class="inner">
					<!-- ▼ 健診予約申込み -->
					<h2>健診予約申込み</h2>
					<ul class="note">
						<li>ご不明な点がございましたら、下記お問合せ先までお電話にてお問い合わせ下さい。</li>
					</ul>
					<ul class="contact">
						<li class="tel"><b>{{getCommonKtel}}</b></li>
						<li class="open">{{getCommonUktj}}</li>
					</ul>
				</div>
			</section>
			<!-- △ 雲財 仮追加ここまで  ログインページでは不要 CSSで非表示設定 ★ -->
			<router-view />
		</div>
		<footer id="mainAF" v-if="!isCommon">
			<!--<h2>けんしんWEB 管理者様用</h2><p class="copy">&copy; {{getAdminUserName}} Online Reservation Service</p>-->
		</footer>
		<footer id="mainCF" v-if="isCommon">
			<!--<h2>けんしんWEB</h2><p class="copy">&copy; {{getCommonIrnm}} Online Reservation Service</p>-->
		</footer>
	</div>
</template>

<script>
	import * as types from '@/store/mutation-types'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'App',
		// データ
		data() {
			return {
			}
		},
		// 算出プロパティ
		computed: {
			// 管理者ユーザー名の取得
			getAdminUserName: function () {
				return this.$store.getters.getAdminUserName
			},
			// 管理者としてログインしているかどうか
			isAdminUserLogin: function () {
				return this.$store.getters.isAdminUserLogin
			},
			// 管理者のヘッダーフッターを出す条件
			isAdminHeaderFooterShow: function () {

				// 管理者としてログインしているか
				var resultAdminUserLogin = this.$store.getters.isAdminUserLogin

				// 管理者としてログインしていないが管理者用のページにいるとき
				var resultAdminPage = ('AdminLogin' == this.$route.name)

				return (resultAdminUserLogin || resultAdminPage)
			},
			// 管理者用グローバルメニュー　予約管理リンク表示できるかどうか
			isAdminGlobalMenuReserve: function () {
				// 管理者ログインしているかつ
				// グローバルメニューが2:予約管理系メニュー表示であること
				return this.$store.getters.isAdminUserLogin
				  && this.$store.state.adminUserChoice.statusGlobalMenu == '2'
			},
			// 管理者用グローバルメニュー　マスタ管理リンク表示できるかどうか
			isAdminGlobalMenuMaster: function () {
				// 管理者ログインしているかつ
				// グローバルメニューが3:マスタ管理系メニュー表示であること
				return this.$store.getters.isAdminUserLogin
					&& this.$store.state.adminUserChoice.statusGlobalMenu == '3'
			},
			// 一般ユーザー受診医療機関の取得
			getCommonIrnm: function () {
				return this.$store.getters.getCommonIrnm
			},
			// 一般ユーザーとしてログインしているかどうか
			isCommonUserLogin: function () {
				return this.$store.getters.isCommonUserLogin
			},
			// ログイン済みの一般ユーザーのヘッダーフッターを出す条件
			// 一般ユーザーとしてログインしているまたは
			// 一般ユーザーとしてログインしていないが一般ユーザーのページにいるとき表示
			isCommonHeaderFooter: function () {

				// 一般ユーザーとしてログインしているか
				var resultCommonUserLogin = this.$store.getters.isCommonUserLogin

				// 一般ユーザーとしてログインしていないが一般ユーザーのページにいるとき
				var resultCommonPage = ('CommonTop' == this.$route.name)
				    || ('CommonForgetPassword' == this.$route.name)
				    || ('CommonForgetPassword2' == this.$route.name)
					|| ('CommonNewHealthInsurance' == this.$route.name)
					|| ('CommonSelectCourse' == this.$route.name)
					|| ('CommonSelectOption' == this.$route.name)
					|| ('CommonSelectCalender' == this.$route.name)
					|| ('CommonInputReserveInfo' == this.$route.name)
					|| ('CommonConfirmReserveInfo' == this.$route.name)

				// どちらか満たしていればtrueを返す（表示する）
				return (resultCommonUserLogin || resultCommonPage)
			},
			// 一般ユーザーのヘッダー、コンテンツ、フッター（mainCH、mainCC、mainCF）を表示する条件
			isCommon: function() {

				// 一般ユーザーのページにいるとき
				var resultCommonPage = ('CommonTop' == this.$route.name)
          || ('CommonLogin' == this.$route.name)
					|| ('CommonMyPage' == this.$route.name)
					|| ('CommonChangePassword' == this.$route.name)
					|| ('CommonChangePassword2' == this.$route.name)
					|| ('CommonConfirmCancel' == this.$route.name)
					|| ('CommonConfirmCancel2' == this.$route.name)
					|| ('CommonReserveDetail' == this.$route.name)
				  || ('CommonForgetPassword' == this.$route.name)
					|| ('CommonForgetPassword2' == this.$route.name)
					|| ('CommonNewHealthInsurance' == this.$route.name)
					|| ('CommonSelectCourse' == this.$route.name)
					|| ('CommonSelectOption' == this.$route.name)
					|| ('CommonSelectCalender' == this.$route.name)
					|| ('CommonInputReserveInfo' == this.$route.name)
					|| ('CommonConfirmReserveInfo' == this.$route.name)
					|| ('CommonReserveResult' == this.$route.name)


				return resultCommonPage
			},
			// 一般ユーザーの名前
			getCommonUserName: function () {
				return this.$store.getters.getCommonUserName
			},
			// 契約先 電話番号
			getCommonKtel: function() {
				return this.$store.state.commonUserInfo.ktel
			},
			// 電話予約受付時間
			getCommonUktj: function() {
				return this.$store.state.commonUserInfo.uktk
			},
			// ナビゲーション用の切り替え
			getNavigationClassName: function () {

				var resultClassName = ""

				if(this.$store.state.commonUserInfo.isDisplayNavigation) {
					resultClassName = "menuOn"
				}

				return resultClassName
			},
    	getStyle: function() {

    	  var resultStyle = ''

    	  var strPre = "background-image: url('"
    	  var strPost = "')"

    	  if(this.$store.state.commonUserInfo.hmpg != '') {
    	    resultStyle =  strPre + this.$store.state.commonUserInfo.hmpg + strPost
				}

    	  return resultStyle
    	}
		},
		methods: {
			// 一般ユーザーのTop画面にいるかどうか
			isCommonTop: function() {
				return 'CommonTop' == this.$route.name
			},
			// ログアウトボタン
			onAdminLogout: function () {

				UtilityConsoleLog.consoleLog('AdminLogin::onAdminLogout Start')

				// 管理者ユーザーとしてログインしているかどうか
				var resultAdminUserLogin = this.$store.getters.isAdminUserLogin

				// 一般ユーザーとしてログインしているか
				//var resultCommonUserLogin = this.$store.getters.isCommonUserLogin

				if(resultAdminUserLogin){
					// 管理者ログアウト
					this.$store.commit(types.ADMIN_AUTH_LOGOUT)

					this.$router.push('/AdminLogin')
				} /*else if(resultCommonUserLogin){
					// 一般ユーザーログアウト
				}*/

				UtilityConsoleLog.consoleLog('AdminLogin::onAdminLogout End')
			},
			// 管理者用グローバルメニューを閉じる
			onClickCloseGlobalMenu: function () {

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuTop Start')

				// ストアに保存
				this.$store.commit(
					types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
					{
						statusGlobalMenu: '0'
					}
				)

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuTop End')
			},
			// 管理者用グローバルメニュー　TOPリンク押下時
			onClickGlobalMenuTop: function () {

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuTop Start')

				// TODO:仕様確認中
				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuTop End')
			},
			// 管理者用グローバルメニュー　予約管理リンク押下時
			onClickGlobalMenuReserve: function () {

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuReserve Start')

				if (this.$store.state.adminUserChoice.statusGlobalMenu != '2') {
					// 現在、2:予約管理系メニュー表示以外を表示している場合は
					// 2:予約管理系メニューを表示する
					this.$store.commit(
						types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
						{
							statusGlobalMenu: '2'
						}
					)
				} else if (this.$store.state.adminUserChoice.statusGlobalMenu == '2') {
					// 現在、2:予約管理系メニューを表示している場合は
					// 0:デフォルト表示（何も表示しない）を表示する
					this.$store.commit(
						types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
						{
							statusGlobalMenu: '0'
						}
					)
				}

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuReserve End')
			},
			// 管理者用グローバルメニュー　マスタ管理リンク押下時
			onClickGlobalMenuMaster: function () {

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuMaster Start')

				if (this.$store.state.adminUserChoice.statusGlobalMenu != '3') {
					// 現在、3:マスタ管理系メニュー以外を表示している場合は
					// 3:マスタ管理系メニューを表示する

					// ストアに保存
					this.$store.commit(
						types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
						{
							statusGlobalMenu: '3'
						}
					)
				} else if (this.$store.state.adminUserChoice.statusGlobalMenu == '3') {
					// 現在、3:マスタ管理系メニューを表示している場合は
					// 0:デフォルト表示（何も表示しない）を表示する

					// ストアに保存
					this.$store.commit(
						types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
						{
							statusGlobalMenu: '0'
						}
					)
				}

				UtilityConsoleLog.consoleLog('AdminLogin::onClickGlobalMenuMaster End')
			},
			// グローバルメニューのアクティブ時のクラスを決める
			getIsActive: function(menuType) {

				UtilityConsoleLog.consoleLog('AdminLogin::getIsActive Start')

				if (this.$store.state.adminUserChoice.statusGlobalMenu == menuType) {
					UtilityConsoleLog.consoleLog('AdminLogin::getIsActive End')
					return 'active'
				} else {
					UtilityConsoleLog.consoleLog('AdminLogin::getIsActive End')
					return ''
				}
			},
			// グローバルメニューをクリックしたとき
			// 各画面に遷移する
			onClickGlobalMenuLink: function(pageNo){

				if(pageNo == 0){
					// 医療機関情報マスタ
					if("MasterWIRKNUpdate" != this.$route.name) {
						this.$router.push("/MasterWIRKNUpdate")
					}
				} else if(pageNo == 1) {
					// メールテンプレートマスタ
					if("MasterWMAILList" != this.$route.name) {
						this.$router.push("/MasterWMAILList")
					}
				} else if(pageNo == 2) {
					// 休業日マスタ
					if("MasterWCALM" != this.$route.name) {
						this.$router.push("/MasterWCALM")
					}
				} else if(pageNo == 3) {
					// 検査項目マスタ
					if("MasterWKKMMList" != this.$route.name) {
						this.$router.push("/MasterWKKMMList")
					}
				} else if(pageNo == 4) {
					// オプション分類マスタ
					if("MasterWOPBRList" != this.$route.name) {
						this.$router.push("/MasterWOPBRList")
					}
				} else if(pageNo == 5) {
					// オプション項目マスタ
					if("MasterWOPKMList" != this.$route.name){
						this.$router.push("/MasterWOPKMList")
					}
				} else if(pageNo == 6) {
					// 時間帯マスタ
					if("MasterWTMZNList" != this.$route.name){
						this.$router.push("/MasterWTMZNList")
					}
				} else if(pageNo == 7) {
					// 予約枠マスタ
					if("MasterWWAKUList" != this.$route.name){
						this.$router.push("/MasterWWAKUList")
					}
				} else if(pageNo == 8) {
					// 予約登録枠数管理マスタ
					if("MasterWWKKR" != this.$route.name){
						this.$router.push("/MasterWWKKR")
					}
				} else if(pageNo == 9) {
					// クライアントマスタ
					if("MasterWJGYOList" != this.$route.name){
						this.$router.push("/MasterWJGYOList")
					}
				} else if(pageNo == 10) {
					// コースマスタ
					if("MasterWIRKSList" != this.$route.name){
						this.$router.push("/MasterWIRKSList")
					}
				} else if(pageNo == 51) {
					// 状況照会
					if("AdminReserveStatusCheck" != this.$route.name){
						this.$router.push("/AdminReserveStatusCheck")
					}
				} else if(pageNo == 52) {
					// 受診者抽出
					if("WIGA1" != this.$route.name){
						this.$router.push("/WIGA1")
					}
				} else if(pageNo == 53) {
					// CSVパターン一覧
					if("CSVPatternList" != this.$route.name){
						this.$router.push("/CSVPatternList")
					}
				}

				// ストアに保存
				this.$store.commit(
					types.ADMIN_USERCHOICE_STATUSGLOBALMENU,
					{
						statusGlobalMenu: '0'
					}
				)
			},
			// ホームリンク押下時
			onHome: function() {

				// ログインしている場合
				if(this.$store.getters.isCommonUserLogin) {
					// ストア値（各画面の選択値）のリセット
					this.$store.commit(types.COMMON_TO_MYPAGE)
					// マイページ画面に遷移する
					this.$router.push('CommonMyPage')
				} else{
        	// ストアの状況に関わらず
        	// ログアウト処理を行う
        	this.$store.commit(types.COMMON_AUTH_LOGOUT)
					// URLパラム
					var tempParam = this.$store.getters.getCommonParam
					// 一般ユーザーTop画面に遷移する
					this.$router.push('/CommonTop/' + tempParam)
				}
			},
			// ログアウトリンク押下時
			onLogout: function() {
        // ストアの状況に関わらず
        // ログアウト処理を行う
        this.$store.commit(types.COMMON_AUTH_LOGOUT)
				// URLパラム
				var tempParam = this.$store.getters.getCommonParam
				// 一般ユーザーTop画面に遷移する
				this.$router.push('/CommonTop/' + tempParam)
			},
			// パスワード変更リンク押下時
			onChangePassword: function() {
				// ストア値（各画面の選択値）のリセット
				this.$store.commit(types.COMMON_TO_CHANGEPASSWORD)
				// パスワード変更画面に繊維
				this.$router.push('CommonChangePassword')
			},
			// メニュークリック時
			// ナビゲーション表示の切り替え
			onMenu: function () {
				UtilityConsoleLog.consoleLog('App::onMenu Start')
				// ストアに保存
				this.$store.commit(
					types.COMMON_DISPLAYNAVIGATION,
					{
						isDisplayNavigation: !this.$store.state.commonUserInfo.isDisplayNavigation
					}
				)
				UtilityConsoleLog.consoleLog('App::onMenu End')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue